<template>
  <v-dialog v-model="show" max-width="1000" persistent>
    <v-card>
      <v-card-title class="grey lighten-3">
        <v-row>
          <v-icon class="draggable">mdi-drag</v-icon>
          <v-col class="py-0">Edit Tax</v-col>
        </v-row>
      </v-card-title>
      <v-card-text class="pb-0">
        <v-row>
          <v-col sm="4">
            <date-range-picker
              :gt-date-from-string="validFrom"
              :gt-date-to-string="validTo"
              @onRangeSelected="onDateRangeSelected"
              :outlined="outlinedInputs"
            ></date-range-picker>
          </v-col>
          <v-col>
            <v-text-field type="text" label="Name" v-model="name" :outlined="outlinedInputs"></v-text-field>
          </v-col>
          <v-col>
            <v-text-field type="text" label="Code" v-model="code" :outlined="outlinedInputs"></v-text-field>
          </v-col>
          <v-col sm="2">
            <v-text-field
              type="number"
              label="Percent"
              v-model="percent"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row v-if="debug">
          <v-col></v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="grey lighten-4">
        <div class="flex-grow-1"></div>
        <v-btn color="warning" text @click="$emit('close')">Cancel</v-btn>
        <v-btn color="primary" @click="onSave">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DateRangePicker from "../../shared/DatesRangePicker";
export default {
  name: "tax-item-editor",
  props: {
    value: {
      type: Object,
      default: () => null
    },
    show: {
      type: Boolean,
      default: () => false
    }
  },

  components: { DateRangePicker },

  data() {
    return {
      debug: false,
      validFrom: "",
      validTo: "",
      code: "",
      name: "",
      percent: 0
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    }
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.validFrom = newVal.validTo;
        this.validTo = newVal.validTo;
        this.percent = Number(newVal.percent);
        this.code = newVal.code;
        this.name = newVal.name;
      }
    }
  },

  methods: {
    onSave() {
      this.$emit("input", {
        ...this.value,
        name: this.name,
        percent: this.percent
      });
    },
    onDateRangeSelected(range) {
      this.validFrom = range.dateFrom;
      this.validTo = range.dateTo;
    }
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/suppliers/taxes/TaxItemEditor.vue